import { z } from 'zod';
export const ApiEnvSchema = z
    .object({
    ENVIRONMENT: z.enum(['local', 'staging', 'production']),
    STORE_ORIGIN: z.string().url(),
    ADMIN_ORIGIN: z.string().url(),
    API_ORIGIN: z.string().url(),
    BOT_ORIGIN: z.string().url(),
    CDN_ORIGIN: z.string().url(),
    MGMT_BOT_USERNAME: z.string().min(1),
    MGMT_BOT_ID: z.coerce.number().int().positive(),
    TELEGRAM_PUBLIC_KEYS: z.string().min(1), // Ed25519 public keys JSON or PEM
    CALLBACK_SIGNING_KEY: z.string().min(16),
    JWT_SECRET: z.string().min(16),
    ADMIN_SESSION_PEPPER: z.string().min(16).optional(),
    RELEASE_COMMIT: z.string().optional(),
    // Strictly prohibited in API Worker (SET-10)
    MGMT_BOT_TOKEN: z.undefined().optional(),
    TOKEN_ENCRYPTION_KEYS: z.undefined().optional(),
    WEBHOOK_SECRET_MASTER: z.undefined().optional(),
})
    .superRefine((data, ctx) => {
    // Check forbidden keys if someone passed them in raw object
    const raw = data;
    if (raw['MGMT_BOT_TOKEN']) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'MGMT_BOT_TOKEN must not be provided to the api Worker (least privilege SET-10)',
        });
    }
    if (raw['TOKEN_ENCRYPTION_KEYS']) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'TOKEN_ENCRYPTION_KEYS must not be provided to the api Worker (least privilege SET-10)',
        });
    }
    if (raw['WEBHOOK_SECRET_MASTER']) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'WEBHOOK_SECRET_MASTER must not be provided to the api Worker (least privilege SET-10)',
        });
    }
});
export const BotEnvSchema = z
    .object({
    ENVIRONMENT: z.enum(['local', 'staging', 'production']),
    STORE_ORIGIN: z.string().url(),
    API_ORIGIN: z.string().url(),
    BOT_ORIGIN: z.string().url(),
    CDN_ORIGIN: z.string().url(),
    MGMT_BOT_USERNAME: z.string().min(1),
    MGMT_BOT_ID: z.coerce.number().int().positive(),
    MGMT_BOT_TOKEN: z.string().min(1),
    TOKEN_ENCRYPTION_KEYS: z.string().min(1), // JSON map version -> base64
    TOKEN_ENCRYPTION_ACTIVE_VERSION: z.string().min(1),
    WEBHOOK_SECRET_MASTER: z.string().min(16),
    CALLBACK_SIGNING_KEY: z.string().min(16),
    BOOTSTRAP_SECRET: z.string().optional(),
    RELEASE_COMMIT: z.string().optional(),
    // Strictly prohibited in Bot Worker (SET-10)
    JWT_SECRET: z.undefined().optional(),
    ADMIN_ORIGIN: z.undefined().optional(),
})
    .superRefine((data, ctx) => {
    const raw = data;
    if (raw['JWT_SECRET']) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'JWT_SECRET must not be provided to the bot Worker (least privilege SET-10)',
        });
    }
});
//# sourceMappingURL=env.js.map